module.exports = __webpack_public_path__ + "static/media/dropper.7ff5bb64.svg";